var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"admin-container",attrs:{"element-loading-background":"white"}},[_c('el-header',{staticClass:"header__nav"},[_c('admin-header',{staticClass:"header--padding"})],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }